module.exports = __webpack_public_path__ + "img/6.59bdbb0b.png";